import React from 'react';
import { tr } from '../../i18n';
import { buildSteamLoginUrl } from '../../auth';
import { rememberPostLoginPath } from '../../auth/postLoginPath';
import './system-states.css';

type LoginGateStateProps = {
  title?: string;
  description?: string;
  returnTo?: string;
  onWhatIsAvailable?: () => void;
};

const LoginGateState: React.FC<LoginGateStateProps> = ({
  title = tr.shell.systemStates.loginGateTitle,
  description = tr.shell.systemStates.loginGateDescription,
  returnTo,
  onWhatIsAvailable
}) => {
  const handleLogin = () => {
    if (returnTo) rememberPostLoginPath(returnTo);
    window.location.href = buildSteamLoginUrl();
  };

  return (
    <div className="sys-state">
      <div className="sys-state-icon-wrap sys-state-icon-wrap--accent">S</div>
      <h3 className="sys-state-title">{title}</h3>
      {description && <p className="sys-state-desc">{description}</p>}
      <div className="sys-state-actions">
        <button type="button" className="sys-state-btn sys-state-btn--primary" onClick={handleLogin}>
          {tr.common.sidebar.loginWithSteam}
        </button>
        {onWhatIsAvailable && (
          <button type="button" className="sys-state-btn sys-state-btn--outline" onClick={onWhatIsAvailable}>
            {tr.shell.systemStates.whatIsAvailable}
          </button>
        )}
      </div>
    </div>
  );
};

export default LoginGateState;
